export const conflictingSources: string[] = [
  'One video explains how to set up a MIG machine.',
  'A book chapter covers welding symbols.',
  'A handout from years ago explains striking an arc.',
  'Your old notes cover TIG tungsten prep.',
]

export const symptoms: string[] = [
  'And when you need material for shop safety, machine setup, MIG, TIG, stick, blueprints, inspection or assessments...',
  'You’re searching all over again.',
]

export const needsIntro = 'Then your next class or workshop arrives.'

export const needsList: string[] = [
  'You need a clear visual of the machine, the joint or the technique.',
  'You need the setup and welding steps broken down one by one.',
  'You need booth drills and practice coupons that actually engage your students.',
  'You need ❌/✅ comparisons that correct the most common welding mistakes.',
  'And you need a clear way to see who is really ready for the next position or process.',
]

export const searchQuestions: string[] = [
  'What should I teach in today’s class?',
  'How do I explain voltage and wire feed speed so students set them correctly?',
  'How do I teach gun, torch and electrode angles step by step?',
  'How do I correct porosity, undercut or lack of fusion that keeps coming back?',
  'How do I make welding symbols and prints click for every student?',
  'How do I give feedback at the booth without discouraging anyone?',
  'Where do I find clear visual material for TIG, stick and inspection?',
  'How can I plan better classes without spending hours every week?',
]

export const painPoints: string[] = [
  'Rebuilding classes and workshops from scratch every week.',
  'Hours searching scattered books, videos, handouts and notes.',
  'Explaining arc control, angles and machine settings with words alone.',
  'Students following steps without understanding why.',
  'No visual material for the booth, the welding table or the classroom.',
  'Repeating the same corrections every class.',
  'Assessing welds and skills without clear criteria.',
  'Losing time you could spend actually teaching.',
  'And constantly wondering if your next class will be good enough.',
]

export const systemShows: string[] = [
  'WHAT TO TEACH.',
  'WHAT TO SHOW.',
  'HOW TO EXPLAIN IT.',
  'HOW TO CORRECT ERRORS.',
  'HOW TO STRUCTURE THE CLASS.',
  'HOW TO ASSESS EACH SKILL.',
]
